import { useState } from 'react';
//import Card from '@mui/material/Card';
import { Box, Card } from '@mui/material';

const RotatingCard = ({ children }) => {
    const [rotate, setRotate] = useState(false);

    const rotate0 = () => setRotate(false);
    const rotate180 = () => setRotate(true);

    return (
        <Box
            sx={{ perspective: '50rem' }}
            onMouseEnter={rotate180}
            onMouseLeave={rotate0}
        >
            <Card
                sx={{
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    position: 'relative',
                    transformStyle: 'preserve-3d',
                    transform: rotate ? 'rotateY(180deg)' : 'rotateY(0)',
                    transition: 'all 0.8s cubic-bezier(0.34, 1.45, 0.7, 1)',
                    overflow: 'visible',
                    borderRadius: 3,
                    cursor: 'pointer',
                }}
            >
                {children}
            </Card>
        </Box>
    );
};

export default RotatingCard;
